export const environment = {
  production: true,
  hmr: false,
  apiUrl: "https://api.utrav.ma",
  graphqlUrl: "https://api.utrav.ma",
  graphqlWs: "wss://api.utrav.ma",
  vapikey:
    "BHC_0BrLj44eKSw-Ts54Ji0XnsA8iiaYutoLJZdYtEeJ0yzo5pGMA2-ninKV9zlKbowRaAWppHKe58zEbXiRJtI",
  firebase: {
    apiKey: "AIzaSyBQwKlC9IDAHHCzKlrRHhnCKiUbXwoolDg",
    authDomain: "utrav-mobile-576fa.firebaseapp.com",
    projectId: "utrav-mobile-576fa",
    storageBucket: "utrav-mobile-576fa.firebasestorage.app",
    messagingSenderId: "411494059926",
    appId: "1:411494059926:web:ea96315fad1f05cc0ed7b7",
  },
};
